import { CsvDownloader } from './file/csv.downloader';
import { Downloader, DownloadType } from './interfaces/downloader.interface';
import { PdfDownloader } from './file/pdf.downloader';
import { XlsxDownloader } from './file/xlsx.downloader';

export class DownloaderFactory {
  /**
   * Instantiates the appropriate downloader based on the download type.
   *
   * @param downloadType
   * @param fileName
   * @param sheetName
   */
  static getDownloader(
    downloadType: DownloadType,
    fileName: string,
    sheetName = ''
  ): Downloader {
    switch (downloadType) {
      case DownloadType.CSV:
        return new CsvDownloader(fileName);
      case DownloadType.PDF:
        return new PdfDownloader(fileName);
      case DownloadType.XLSX:
        return new XlsxDownloader(fileName, sheetName);
      default:
        throw new Error('Invalid download type');
    }
  }
}
